<template>
  <!-- start breadcrumbs -->
  <!-- если не главная выводить сюда-->
  <section class="section-breadcrumb">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 breadcrumb-wrapp">
          <ul class="breadcrumb">
            <li>
              <router-link to="/stations" itemprop="item"><span>Главная</span></router-link>
            </li>
            <li v-for="(link, index) in parameters" :class="[(index === (parameters.length - 1)) ? 'active' : '']" :key="index">
              <span v-if="(index === (parameters.length - 1))">{{link.title}}</span>
              <router-link v-else v-bind:to="link.url" ><span>{{link.title}}</span></router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <!-- end breadcrumbs -->
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: {
    parameters: Array
  },
  methods: {

  }
}
</script>
